import axios from '../../utils/axios'
import CustomError from '../../utils/custom-error'

const USER_CERTIFICATE_NOT_FOUND = 'Nema certifikata od korisnika'
const DOCUMENTS_NOT_SIGNED = 'Documents returned form tsp are empty'
const MULTIPLE_DOCUMENT_ERROR = 'Multiple document error'
const MIDDLEWARE_NOT_FOUND = 'Programska podrška odabranog pružatelja usluge povjerenja nije dostupna na vašem računalu.'

export const getUserCertificateFromLocalSigner = async (signerUrl) => {
  try {
    const response = await axios.get(signerUrl)
    const { userCertificate } = response.data
    if (!userCertificate) {
      // baciti grešku nema certifikat ili nešto
      throw new CustomError(USER_CERTIFICATE_NOT_FOUND, { message: USER_CERTIFICATE_NOT_FOUND ,code: 25})
    }
    
    return userCertificate 
  } catch (error) {
    throw error
  }
}


export const sendHashToSign = async (data, signerUrl) => {
  try {
    if (data.documents.length !== 1) {
      throw new CustomError(MULTIPLE_DOCUMENT_ERROR, { message: MULTIPLE_DOCUMENT_ERROR ,code: 29})
    }
    const response = await axios.post(signerUrl, data)

    const { userCertificate, documents } = response.data
    if (!userCertificate || !documents) {
      throw new CustomError(USER_CERTIFICATE_NOT_FOUND, { message: USER_CERTIFICATE_NOT_FOUND ,code: 25})
    }

    if (!documents.length) {
      throw new CustomError(DOCUMENTS_NOT_SIGNED, { message: DOCUMENTS_NOT_SIGNED ,code: 28})
    }


    


    // ovo radimo da bi dodali mimetype u dokument jer fina mw vraca mimeType
    /// i da maknemo mimeType
    const newDocs = documents.map(({mimeType, ...rest}) => ({
      ...rest,
      mimetype: data.mimetype, 
    }))   
    
    const certHex = Buffer.from(userCertificate, 'base64').toString('hex')
    return { 
      userCertificate: certHex, 
      documents: newDocs 
    }

  } catch (error) {
    throw error
  }
}

export const sendHashToCloudSign = async (data, signerUrl) => {
  try {
  
    const response = await axios.post(signerUrl, data)
    
    const { userCertificate, documents } = response.data
    if (!userCertificate || !documents) {
      throw new CustomError(USER_CERTIFICATE_NOT_FOUND, { message: USER_CERTIFICATE_NOT_FOUND ,code: 25})
    }

    if (!documents.length) {
      throw new CustomError(DOCUMENTS_NOT_SIGNED, { message: DOCUMENTS_NOT_SIGNED ,code: 28})
    }


    


    // ovo radimo da bi dodali mimetype u dokument jer fina mw vraca mimeType
    /// i da maknemo mimeType
    const newDocs = documents.map(({mimeType, ...rest}) => ({
      ...rest,
      mimetype: data.mimetype, 
    }))   
    
    const certHex = Buffer.from(userCertificate, 'base64').toString('hex')
    return { 
      userCertificate: certHex, 
      documents: newDocs 
    }

  } catch (error) {
    throw error
  }
}
